// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pageNavigator":"pageNavigator-3nwEw","indicator":"indicator-3_ET1"};